<script setup>
import { onBeforeMount} from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import bootstrap from "bootstrap/dist/js/bootstrap";
import router from "../router";
import cookies from "../assets/js/cookies.js";
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";
import { computed } from "vue";

const setSidebarType = (type) => store.commit("sidebarType", type);

const darkMode = () => {
  if (store.state.darkMode) {
    store.state.darkMode = false;
    setSidebarType("bg-white");
    deactivateDarkMode();
  } else {
    store.state.darkMode = true;
    setSidebarType("bg-default");
    activateDarkMode();
  }

  updateUser();
  return;

};

const store = useStore();

const darkModeProfile = computed(() => store.state.darkMode);

const getData = async () => {

  axios.get('users/data')
  .then(res => {

      if(res.status == 200){

          store.state.user = res.data;

          if(res.data.darkmode == 'No'){
            store.state.user.darkmode = false;
          }
          else{
            store.state.user.darkmode = true;
          }

      }

  })
  .catch(err => {
      console.error(err); 
  })

}

onBeforeMount(() => {

  store.state.user = {
    name: '',
    email: '',
    birthdate: '',
    sex: '',
    cep: '',
    street: '',
    neighborhood: '',
    city: '',
    state: '',
    number: '',
    password: '',
    new_password: '',
    password_confirmation: '',
    darkmode: false
  };

  store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        passwordHasError: false,
        passwordMessageError: '',
        newPasswordHasError: false,
        newPasswordMessageError: '',
        passwordConfirmationHasError: false,
        passwordConfirmationMessageError: '',        
    };

  getData();
});

const getCep = async () => {

  if(store.state.user.cep.length == 8){

    axios.get('/helpers/cep/'+store.state.user.cep)
    .then(res => {

      if(res.status == '200'){

        store.state.user.street = res.data.logradouro;
        store.state.user.neighborhood = res.data.bairro;
        store.state.user.city = res.data.localidade;
        store.state.user.state = res.data.uf;

        document.getElementById('house-number').focus();

      }

    })
    .catch(err => {
      console.error(err); 
    })

  }  

}

const updateUser = async () => {

  store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        passwordHasError: false,
        passwordMessageError: '',
        newPasswordHasError: false,
        newPasswordMessageError: '',
        passwordConfirmationHasError: false,
        passwordConfirmationMessageError: '',        
    };

  let url = '/users/update';

  let data = new FormData();

  data.append('name', store.state.user.name);
  data.append('birthdate', store.state.user.birthdate);
  data.append('sex', store.state.user.sex);
  data.append('cep', store.state.user.cep);
  data.append('street', store.state.user.street);
  data.append('number', store.state.user.number);
  data.append('neighborhood', store.state.user.neighborhood);
  data.append('city', store.state.user.city);
  data.append('state', store.state.user.state);
  data.append('password', store.state.user.password);
  data.append('new_password', store.state.user.new_password);
  data.append('password_confirmation', store.state.user.password_confirmation);
  data.append('darkmode', !store.state.user.darkmode ? 'No' : 'Yes');

  axios.post(url, data)
  .then(res => {
    console.log(res)

    if(res.data.error){

      let messages = res.data.messages;

      Object.entries(messages).forEach((value) => {

          if(value[0] == 'name'){
              store.state.validation.nameHasError = true;
              store.state.validation.nameMessageError = value[1];
          }
          else if(value[0] == 'password'){
              store.state.validation.passwordHasError = true;
              store.state.validation.passwordMessageError = value[1];
          }
          else if(value[0] == 'new_password'){
              store.state.validation.newPasswordHasError = true;
              store.state.validation.newPasswordMessageError = value[1];
          }
          else if(value[0] == 'password_confirmation'){
              store.state.validation.passwordConfirmationHasError = true;
              store.state.validation.passwordConfirmationMessageError = value[1];
          }
          else if(value[1] == 'Senha inválida'){
            store.state.validation.passwordHasError = true;
            store.state.validation.passwordMessageError = value[1];
          }

      })

      store.state.savingTransaction = false;

    }
    else{

      toast(res.data.message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

    }

  })
  .catch(err => {
    console.error(err); 
  })

}

const closeModal = (id) => {

  let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

  modal.hide();

}

const openModal = (id) => {

  let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

  modal.show();

}

const deleteAccount = () => {

  let url = '/users/'+store.state.user.id;

  let data = new FormData();

  axios.delete(url, data)
  .then(res => {

      if(!res.data.error){

          closeModal('deleteAccount');

          toast('Conta excluída com sucesso! Em alguns segundos você será deslogado.', {
              autoClose: 1000,
              theme: "auto",
              type: "success",
              transition: "slide",
              onClose: () => logout(),
          });

      }

  })
  .catch(err => {
      console.error(err); 
  })

}

const logout = () => {

  let session = cookies.get('user_agive_session');

  axios.get('/helpers/logout?session='+session)
  .then(res => {

    console.log(res);

    if(res.data.error){

      alert(res.data);

    }
    else{

      cookies.remove('user_agive_session');

      router.push({name: 'Login'});

    }

  })
  .catch(err => {
    console.error(err); 
  })

}

</script>

<template>
  <main>
    <div class="py-4 container-fluid overflow-auto max-height-vh-90 profile-page">
      <div class="row">
        <div class="col-md-12">
          <div class="card profile-shell border-0">
            <div class="card-header profile-header border-0">
              <div class="profile-header-top">
                <div class="profile-title-wrap">
                  <span class="profile-eyebrow">Minha conta</span>
                  <h3 class="profile-title">Meu perfil</h3>
                  <p class="profile-subtitle mb-0">Atualize seus dados, personalize sua experiência e mantenha sua conta segura.</p>
                </div>
              </div>
            </div>

            <div class="card-body profile-body">
              <div class="profile-section-card">
                <div class="profile-section-head">
                  <h5>Meus dados</h5>
                </div>

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="profile-label">Nome</label>
                    <input class="form-control profile-input" type="text" v-model="store.state.user.name" v-bind:class="{
                      'is-invalid': store.state.validation.nameHasError,
                      'darkmode': darkModeProfile,
                    }"/>
                    <div class="invalid-feedback">
                      {{ store.state.validation.nameMessageError }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label class="profile-label">E-mail</label>
                    <input class="form-control profile-input profile-input-readonly" type="email" v-model="store.state.user.email" readonly v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>

                  <div class="col-md-6">
                    <label class="profile-label">Data de Nascimento</label>
                    <input class="form-control profile-input" type="date" v-model="store.state.user.birthdate"  v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>

                  <div class="col-md-6">
                    <label class="profile-label">Sexo</label>
                    <select class="form-select profile-input" v-model="store.state.user.sex" v-bind:class="{
                      'darkmode': darkModeProfile,
                    }">
                      <option value="" disabled>Selecionar uma opção</option>
                      <option value="M">Masculino</option>
                      <option value="F">Feminino</option>
                      <option value="N">Prefiro não informar</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="profile-section-card">
                <div class="profile-section-head">
                  <h5>Informações adicionais</h5>
                </div>

                <div class="row g-3">
                  <div class="col-md-4">
                    <label class="profile-label">CEP</label>
                    <input class="form-control profile-input" type="text" v-model="store.state.user.cep" maxlength="8" @keyup="getCep()" @change="getCep()" placeholder="00000000" v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>

                  <div class="col-md-8">
                    <label class="profile-label">Logradouro</label>
                    <input class="form-control profile-input"
                      type="text"
                      v-model="store.state.user.street"
                      v-bind:class="{
                        'darkmode': darkModeProfile,
                      }"
                    />
                  </div>

                  <div class="col-md-3">
                    <label class="profile-label">Número</label>
                    <input class="form-control profile-input" id="house-number" type="text" v-model="store.state.user.number" v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>

                  <div class="col-md-3">
                    <label class="profile-label">Bairro</label>
                    <input class="form-control profile-input" type="text" v-model="store.state.user.neighborhood" v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>

                  <div class="col-md-3">
                    <label class="profile-label">Cidade</label>
                    <input class="form-control profile-input" type="text" v-model="store.state.user.city" v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>

                  <div class="col-md-3">
                    <label class="profile-label">Estado</label>
                    <input class="form-control profile-input" type="text" v-model="store.state.user.state" v-bind:class="{
                      'darkmode': darkModeProfile,
                    }"/>
                  </div>
                </div>
              </div>

              <div class="profile-section-card">
                <div class="profile-section-head">
                  <h5>Personalização</h5>
                </div>

                <div class="profile-switch-row">
                  <div class="profile-switch-copy">
                    <strong>Ativar modo escuro</strong>
                    <small>Deixe o aplicativo com aparência escura para reduzir o brilho da interface.</small>
                  </div>

                  <label class="profile-switch">
                    <input
                      id="darkModeCheck"
                      type="checkbox"
                      v-model="store.state.user.darkmode"
                      @change="darkMode"
                    />
                    <span></span>
                  </label>
                </div>
              </div>

              <div class="profile-section-card">
                <div class="profile-section-head">
                  <h5>Segurança</h5>
                </div>

                <div class="row g-3">
                  <div class="col-md-12">
                    <label class="profile-label">Senha Atual</label>
                    <input class="form-control profile-input"
                      type="password"
                      v-model="store.state.user.password"
                      v-bind:class="{
                        'is-invalid': store.state.validation.passwordHasError,
                        'darkmode': darkModeProfile,
                      }"
                    />
                    <div class="invalid-feedback">
                      {{ store.state.validation.passwordMessageError }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label class="profile-label">Nova Senha</label>
                    <input class="form-control profile-input" type="password" v-model="store.state.user.new_password" v-bind:class="{
                      'is-invalid': store.state.validation.newPasswordHasError,
                      'darkmode': darkModeProfile,
                    }"/>
                    <div class="invalid-feedback">
                      {{ store.state.validation.newPasswordMessageError }}
                    </div>
                  </div>

                  <div class="col-md-6">
                    <label class="profile-label">Confirmar Senha</label>
                    <input class="form-control profile-input" type="password" v-model="store.state.user.password_confirmation" v-bind:class="{
                      'is-invalid': store.state.validation.passwordConfirmationHasError,
                      'darkmode': darkModeProfile,
                    }"/>
                    <div class="invalid-feedback">
                      {{ store.state.validation.passwordConfirmationMessageError }}
                    </div>
                  </div>

                  <div class="col-12 text-end mt-2">
                    <button class="btn profile-save-btn" @click="updateUser()">Salvar alterações</button>
                  </div>
                </div>
              </div>

              <div class="profile-danger-card">
                <div class="profile-danger-copy">
                  <h6>Excluir minha conta</h6>
                  <p class="mb-0">Essa ação remove permanentemente seu acesso e seus dados da plataforma.</p>
                </div>

                <button class="btn profile-danger-btn" @click="openModal('deleteAccount')">Excluir conta</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <div class="modal fade" id="deleteAccount" tabindex="-1" aria-labelledby="deleteAccountModal" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content profile-delete-modal">
        <div class="modal-body">
          <div class="profile-delete-modal-inner">
            <h5 class="mb-3">Você tem certeza que deseja excluir sua conta?</h5>
            <p class="mb-4">Essa ação não poderá ser desfeita.</p>

            <div class="d-grid gap-2">
              <button class="btn profile-danger-btn" type="button" @click="deleteAccount()">Sim, excluir</button>
              <button @click="closeModal('deleteAccount')" class="btn profile-cancel-btn" type="button">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.profile-shell{
    overflow: hidden;
    border-radius: 24px !important;
    background: #f6f3eb;
    box-shadow: 0 12px 40px rgba(24, 39, 75, 0.08);
}

.profile-header{
    padding: 1.8rem 1.5rem 1.5rem;
    background: linear-gradient(135deg, #1f4876 0%, #224a78 55%, #1f436d 100%);
}

.profile-header-top{
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:16px;
}

.profile-title-wrap{
    min-width:0;
}

.profile-eyebrow{
    display:inline-block;
    margin-bottom:10px;
    font-size:0.92rem;
    color: rgba(255,255,255,0.78);
}

.profile-title{
    margin:0;
    font-size:2rem;
    line-height:1.1;
    font-weight:800;
    color:#ffffff;
}

.profile-subtitle{
    margin-top:10px;
    color: rgba(255,255,255,0.66);
    font-size:1rem;
}

.profile-body{
    padding:1.4rem !important;
    background:#f7f4ee;
    display:flex;
    flex-direction:column;
    gap:1rem;
}

.profile-section-card,
.profile-danger-card{
    background: rgba(255,255,255,0.88);
    border: 1px solid #dbe5f0;
    border-radius: 22px;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.profile-section-card{
    padding:1rem;
}

.profile-section-head{
    margin-bottom:.9rem;
}

.profile-section-head h5{
    margin:0;
    color:#5b6f95;
    font-size:1.05rem;
    font-weight:800;
    text-transform:uppercase;
    letter-spacing:.02em;
}

.profile-label{
    display:block;
    margin-bottom:.45rem;
    color:#344766;
    font-weight:700;
    font-size:.95rem;
}

.profile-input{
    min-height:54px !important;
    border-radius:15px !important;
    border:1px solid #d7e0ea !important;
    background:#ffffff !important;
    box-shadow:none !important;
    color:#344766;
}

.profile-input:focus{
    border-color:#8aa8ca !important;
    box-shadow:0 0 0 4px rgba(138,168,202,0.14) !important;
}

.profile-input-readonly{
    background:#f8fafc !important;
}

.profile-switch-row{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:1rem;
    padding:.95rem 1rem;
    border:1px solid #dbe5f0;
    border-radius:18px;
    background:#f8fafc;
}

.profile-switch-copy strong{
    display:block;
    color:#344766;
    font-size:.98rem;
}

.profile-switch-copy small{
    display:block;
    margin-top:.15rem;
    color:#6b7c93;
    font-size:.84rem;
}

.profile-switch{
    position:relative;
    display:inline-flex;
    width:52px;
    min-width:52px;
    height:30px;
}

.profile-switch input{
    opacity:0;
    width:0;
    height:0;
}

.profile-switch span{
    position:absolute;
    inset:0;
    border-radius:999px;
    background:#d7e0ea;
    cursor:pointer;
    transition:.2s ease;
}

.profile-switch span::before{
    content:"";
    position:absolute;
    width:22px;
    height:22px;
    top:4px;
    left:4px;
    border-radius:50%;
    background:#ffffff;
    box-shadow:0 2px 8px rgba(15,23,42,0.14);
    transition:.2s ease;
}

.profile-switch input:checked + span{
    background:#d89239;
}

.profile-switch input:checked + span::before{
    transform:translateX(22px);
}

.profile-save-btn{
    min-height:50px;
    padding:0 1.4rem;
    border:none !important;
    border-radius:15px !important;
    background: linear-gradient(135deg, #d89239 0%, #c97d24 100%) !important;
    color:#ffffff !important;
    font-weight:800 !important;
    box-shadow:0 18px 34px rgba(201,125,36,0.24);
}

.profile-save-btn:hover,
.profile-save-btn:focus{
    transform:translateY(-1px);
    color:#ffffff !important;
    background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%) !important;
}

.profile-danger-card{
    padding:1rem 1.1rem;
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:1rem;
    border-color: rgba(239, 68, 68, 0.16);
    background: linear-gradient(180deg, #fff 0%, #fff7f7 100%);
}

.profile-danger-copy h6{
    margin:0 0 .2rem 0;
    color:#991b1b;
    font-size:1rem;
    font-weight:800;
}

.profile-danger-copy p{
    color:#7f1d1d;
    font-size:.9rem;
}

.profile-danger-btn{
    min-height:46px;
    padding:0 1.2rem;
    border:none !important;
    border-radius:14px !important;
    background:#ef4444 !important;
    color:#ffffff !important;
    font-weight:700 !important;
    box-shadow:0 14px 28px rgba(239,68,68,.22);
}

.profile-danger-btn:hover,
.profile-danger-btn:focus{
    color:#ffffff !important;
    background:#dc2626 !important;
}

.profile-delete-modal{
    border:none;
    border-radius:22px;
    overflow:hidden;
}

.profile-delete-modal .modal-body{
    background:#f8f7f3;
}

.profile-delete-modal-inner{
    padding:1rem;
    text-align:center;
}

.profile-delete-modal-inner h5{
    color:#213E60;
    font-weight:800;
}

.profile-delete-modal-inner p{
    color:#6b7c93;
}

.profile-cancel-btn{
    min-height:46px;
    border-radius:14px !important;
    border:1px solid #d7e0ea !important;
    background:#ffffff !important;
    color:#344766 !important;
    font-weight:700 !important;
}

@media (max-width: 991.98px){
    .profile-header{
        padding:1.3rem 1rem 1.2rem;
    }

    .profile-title{
        font-size:1.65rem;
    }

    .profile-body{
        padding:1rem !important;
    }
}

@media (max-width: 575.98px){
    .profile-shell{
        border-radius:20px !important;
    }

    .profile-title{
        font-size:1.35rem;
    }

    .profile-subtitle{
        font-size:.9rem;
    }

    .profile-switch-row,
    .profile-danger-card{
        flex-direction:column;
        align-items:flex-start;
    }

    .profile-danger-btn{
        width:100%;
    }
}
</style>
